import type { QueryFunctionContext } from '@tanstack/react-query';
import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.slugAvailability>>;

export const createFetchOrganizationSlugAvailabilityQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ slug }], signal }: TParams) =>
    call(() => cancelOnSignal(OrganizationsService.isSlugAvailable({ slug }), signal));
